// 阿里云验证码配置
// TODO: 请替换为您的阿里云验证码2.0配置
export const ALIYUN_CAPTCHA_PREFIX = 'your_prefix_here';
export const ALIYUN_CAPTCHA_SCENE_ID = 'your_scene_id_here';
export const ALIYUN_CAPTCHA_SCRIPT_URL = 'https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js';
